import { useEffect } from 'react';
import { useErrorStore } from '../../store/errorStore';

function ErrorToast() {
  const error = useErrorStore((state) => state.error);
  const setError = useErrorStore((state) => state.setError);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(null);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [error, setError]);

  if (!error) return null;

  return (
    <div className="fixed top-4 right-4 bg-red-500 text-white py-2 px-4 rounded shadow-lg z-50">
      {error}
    </div>
  );
}

export default ErrorToast;
